<template>
    <div class="mine">
        <!-- <h3>我的账户</h3> -->
        <div class="headBG">
            <div class="head-icon"><img src="../../assets/testImg/head.png" alt=""></div>
            <p class="user"><span>{{pname}}</span></p>
        </div>
        <ul>
            <li @click="toMyOrder"><i class="iconfont icon-order"></i>我的订单</li>
        </ul>
        <div class="check-out"  @click="goLogin">{{login}}</div>
        <tabbar></tabbar>
        <div class="login-toast-wrap" v-if="closeBtn">
            <div class="login-toast">
                <p>用户登录</p>
                <input ref="phoneInput" class="phone-num" placeholder="请输入手机号" v-model="phoneNum">
                <div class="code-div">
                    <input ref="loginCodeInput" class="code-num" placeholder="输入验证码" v-model="phoneCode">
                    <input type="button" ref="getCodeBtn" @click="getCode" value="获取验证码">
                </div>
                <button @click="doLogin" class="login-btn">登录</button>
                <div class="close-btn" @click="closeLogin"><span style="font-size:15px;" class="iconfont icon-quxiao"></span></div>
            </div>
        </div>
        <mytoast :toastCon="toastCon" :showToast="showToast" ></mytoast>
        <!-- <div class="toast" v-if="showToast">
            {{toastCon}}    
        </div> -->
    </div>
</template>
<script>
import { MessageBox } from 'mint-ui';
import mytoast from '@/basecomponents/Lesin-toast'
import tabbar from '@/basecomponents/foot-tab';
import { Indicator } from 'mint-ui';
export default {
    components: {
        tabbar,
        mytoast,
    },
    data(){
        return {
            userName:"",
            login: "点击登录",
            closeBtn: false,
            isLogin: 1,
            isBuy: 0,
            pname:'未登录',
            phoneNum:'',
            phoneCode:'',
            showToast: 0,
            toastCon:"",
            countdown: 60,
        }
    },
    mounted(){
        var _this = this;
        _this.phoneNum = localStorage.getItem('payPhoneNum') || localStorage.getItem('loginPhoneNum');
        _this.pname =_this.phoneNum ||  "未登录";


        // if(localStorage.getItem('payPhoneNum')){
        //     this.login = "退出登录";
        // }

        
        if(_this.phoneNum){
            this.login = "退出登录";
            this.closeBtn =false;
        }
        else{
            this.closeBtn =false;
            this.login = "点击登录";
            localStorage.clear(); //清除localStorage 退出登录状态
            // return;
        }
    },

    methods: {
        //弹出登陆弹窗
        goLogin(){
            var _this = this;
            // console.log(_this.$store.state.isLogin)
            if(!_this.phoneNum){
                this.closeBtn =true;
                return;
            }else{
                MessageBox.confirm('您确定要退出吗?').then(action => {
 
                    this.phoneNum = '';
                    this.phoneCode= '';
                    this.closeBtn =false;
                    this.login = "点击登录";
                    localStorage.clear(); //清除localStorage 退出登录状态
                    window.location.href = 'http://tc.fanxingzw.com/audio/index.html';// 修复从活动页订购成功进入,无法推出登陆的bug
                    this.$store.state.phoneNum = '';
                    // _this.$store.state.isLogin = 0;
                    // _this.$store.state.phoneNum = "";
                    // _this.$store.state.buyNow = true;
                    // _this.$store.state.isBuy = 0;
                    _this.$router.push({name: 'home'});
                });
            }
        },
        // 关闭登陆弹窗
        closeLogin(){
            this.closeBtn = false;
        },
        // 登陆弹窗的登陆按钮
        doLogin(){
            var _this = this;
            if(_this.isPhone(_this.phoneNum) && this.phoneCode){    
                Indicator.open();
                // 此处请求登陆
                 _this.$ajax.get('http://114.55.87.60:8187/rest/video/login/'+ _this.phoneNum +'/'+_this.phoneCode)
                .then(function (response) {
                    // console.log(response.data);
                    if (response.data === true) {
                        localStorage.setItem("loginPhoneNum",_this.phoneNum);
                        _this.$store.state.phoneNum = _this.phoneNum;
                        _this.$store.state.isLogin = 1;
                        _this.closeLogin();
                        _this.login = "退出登陆"; 
                        _this.pname = _this.phoneNum;
                        Indicator.close();   
                        _this.$ajax.get('http://114.55.87.60:8187/rest/video/role/'+_this.phoneNum)
                        .then(function (response) {
                            // console.log(response);
                            if(response.data === true){
                            // _this.$store.state.hasOrder = 1;
                            // _this.hasOrder = 1;
                            localStorage.setItem('payPhoneNum',_this.phoneNum)
                                   
                            }else{
                                console.log('已登录，没有订阅');
                            }
                        })
                        .catch(function (error) {                           
                            console.log(error);                           
                        });
                    }else{
                        // console.log(111);
                        _this.toastCon = "验证码错误";
                        _this.showToast = 1;
                        setTimeout(function(){
                        _this.showToast = 0;
                        },1000)
                        Indicator.close();
                        return;
                    }
                })
                .catch(function (error) {                    
                    console.log(error);
                });
            }else{
                _this.toastCon = "请输入正确的手机号和验证码";
                _this.showToast = 1;
                setTimeout(function(){
                _this.showToast = 0;
                // Indicator.close();
                },1000)
                return;
            }
        },
        // 获取验证码
        getCode(){
            var _this = this;
            // _this.$store.state.phoneNum = _this.phoneNum;

            
            // console.log(_this.$refs.getCodeBtn);
            //登陆弹窗60S限制
            
            // _this.$refs.getCodeBtn 可以获取元素对象

            // 验证手机号,并将手机号返回后台，以获得短信验证码
            // console.log(_this.isPhone(_this.phoneNum));
            if(_this.isPhone(_this.phoneNum)){
                this.setTime(_this.$refs.getCodeBtn);
                _this.$ajax.get('http://114.55.87.60:8187/rest/video/login/validate/'+_this.phoneNum)
                .then(function (response) {
                    // _this.$refs.phoneInput.setAttribute("readonly", "readonly");
                    // console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });
            }else{
                _this.toastCon = "请输入正确的联通手机号";
                _this.showToast = 1;
                setTimeout(function(){
                _this.showToast = 0;
                },1000)
                return;
            }     
        },
        toMyOrder(){
            var _this = this;
            this.$router.push({name: 'MyOrder'});
            // if(_this.$store.state.isLogin == 1 && _this.$store.state.isBuy ==1){
            //     this.$router.push({name: 'MyOrder'});
            // }else{
            //     this.toastCon = "您还没有订阅哦";
            //     this.showToast = 1;
            //     setTimeout(function(){
            //     _this.showToast = 0;
            //     },1000)
            //     return;
            // }
        },
        //验证码60s计时
        setTime(obj) {
            var _this = this;
            if (this.countdown == 0) {
                obj.removeAttribute("disabled");
                obj.style.backgroundColor = "#28aaff";
                obj.style.color = "#fff";   
                obj.value = "获取验证码";
                _this.countdown = 60;
                return;
            } else {
                obj.setAttribute("disabled", true);
                obj.style.backgroundColor = "#ddd";
                obj.style.color = "#666";
                obj.value = "重新发送(" + _this.countdown + ")";
                 _this.countdown--;
            }
            setTimeout(function () {
                _this.setTime(obj)
            }, 1000)
        },
        // 验证手机号
        isPhone(phone){
            if ((/^((13[0-2])|(145)|(15[5,6])|(17[0,1,5,6])|(18[5,6])|(166))\d{8}$/.test(phone))) {
                return true;
            } else {
                return false;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.mine{
    margin: 0;
    padding: 0;
    h3{
        height: 88px;
        width: 100vw;
        line-height: 88px;
        font-size: 36px;
        font-weight: 500;
        text-align: center;
        background-color: #3a3a3f;
        color: #fff;
    }
    .headBG{
        display: flex;
        flex-direction: column;
        align-items: center;
        // padding: 30px;
        padding: 60px 30px 50px 30px;
        width: 100%;
        height: 320px;
        background-image: url('../../assets/testImg/mine-bg.png');
        background-size: contain;
        background-repeat: no-repeat;
        .head-icon{
            overflow: hidden;
            width: 154px;
            height: 154px;
            background-image: url('~assets/testImg/head.png');
            background-size: cover;
            background-color: #fff;
            // border: 2px solid #222;
            border-radius: 78px;
            img{
                width: 154px;
                height: 154px;
            }
        }
        .user{
            line-height: 36px;
            margin-top: 20px;
            font-size: 30px;
            letter-spacing: 1px;
            color: #fff;
        }
        .profile{
            font-size: 20px;
            color: #fff;
        }
    }
    ul{
        margin-bottom: 12px;
        li{
            padding: 0 30px;
            width: 100vw;
            height: 100px;
            line-height: 100px;
            background-color: #fff;
            margin-bottom: 1px;
            font-size: 27px;
            i{
                font-size: 32px;
                font-weight: 700;
                margin-right: 25px;
            }
        }
        .account{
            height: 100px;
            line-height: 100px;
        }
    }
    .check-out{
        margin-top: 60px;
        width: 90%;
        margin-left: 5%;
        height: 80px;
        line-height: 80px;
        font-size: 32px;
        color: #fff;
        letter-spacing: 3px;
        text-align: center;
        border-radius: 10px;
        background-color: #28aaff;
    }
    .login-toast-wrap{
        position: absolute;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(22, 22, 22, 0.5);
        .login-toast{
            display: flex;
            flex-direction: column;
            // justify-content: space-around;
            align-items: center;
            position: absolute;
            top: 25%;
            left: 10%;
            width: 80%;
            height: 500px;
            font-size: 22px;
            border-radius: 10px;
            background-color: #fff;
            p{
                font-weight: 700;
                font-size: 27px;
                margin-top: 40px;
                margin-bottom: 50px;
            }
            .phone-num{
                width: 80%;
                height: 80px;
                margin-bottom: 40px;
                text-indent: 0.5em;
                border: 1px solid #c4c4c4;
                border-radius: 10px;
            }
            .code-div{
                width: 80%;
                height: 80px;
                margin-bottom: 50px;
                input{
                    width: 65%;
                    height: 80px;
                    margin-right: 5%;
                    text-indent: 0.5em;
                    border: 1px solid #c4c4c4;
                    border-radius: 10px;
                }
                input[type="button"]{
                    float: right;
                    margin-right: 0;
                    width: 30%;
                    height: 80px;
                    color: #fff;
                    background-color: #28aaff;
                    border: none;
                    border-radius: 10px;
                }
            }
            .login-btn{
                width: 80%;
                height: 80px;
                border-radius: 10px;
                background-color: #28aaff;
                color: #fff;
                font-size: 28px;
                font-weight: 700;
            }
            .close-btn{
                position: absolute;
                top: 15px;
                right: 15px;
                width: 30px;
                height: 30px;
                line-height: 30px;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/mine/mine.vue